import { render, staticRenderFns } from "./OneMinute.vue?vue&type=template&id=e97a4f26&scoped=true"
import script from "./OneMinute.vue?vue&type=script&lang=js"
export * from "./OneMinute.vue?vue&type=script&lang=js"
import style0 from "./OneMinute.vue?vue&type=style&index=0&id=e97a4f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97a4f26",
  null
  
)

export default component.exports